import { render, staticRenderFns } from "./DropdownSimple.vue?vue&type=template&id=0b51fbc6"
import script from "./DropdownSimple.vue?vue&type=script&lang=js"
export * from "./DropdownSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports